import {
  ReactComponent as SourcedIcon,
  ReactComponent as ReferenceIcon,
} from '../assets/icons/person_pin_circle.svg';
import { ReactComponent as AppliedIcon } from '../assets/icons/person_add_alt.svg';
import { ReactComponent as ScreeningIcon } from '../assets/icons/contact_phone.svg';
import { ReactComponent as InterviewIcon } from '../assets/icons/person_search.svg';
import { ReactComponent as TechnicalIcon } from '../assets/icons/person_technical.svg';
import { ReactComponent as CulturalIcon } from '../assets/icons/contacts.svg';
import { ReactComponent as OfferIcon } from '../assets/icons/person_offer.svg';
import { ReactComponent as HiredIcon } from '../assets/icons/person_hired.svg';

export const CANDIDATE_ORDERING = {
  NAME_ASC: 'name',
  NAME_DESC: '-name',
  LAST_UPDATE_ASC: 'last_update',
  LAST_UPDATE_DESC: '-last_update',
  ADDED_TO_JOB_ASC: 'added_to_job',
  ADDED_TO_JOB_DESC: '-added_to_job',
};

export const CANDIDATE_ORDERING_DEFAULT = CANDIDATE_ORDERING.NAME_ASC;

export const JOB_VIEW_OPTIONS = [
  {
    value: true,
    name: 'Active',
    key: 'active',
  },
  {
    value: false,
    name: 'Archived',
    key: 'archived',
  },
];

export const RECRUITMENT_STEPS_MAP = {
  SOURCED: {
    id: 'SOURCED',
    key: 'sourced',
    title: 'Sourced',
    icon: SourcedIcon,
  },
  APPLIED: {
    id: 'APPLIED',
    key: 'applied',
    title: 'Applied',
    icon: AppliedIcon,
  },
  SCREENING: {
    id: 'SCREENING',
    key: 'screening',
    title: 'Screening',
    icon: ScreeningIcon,
  },
  INTERVIEW: {
    id: 'INTERVIEW',
    key: 'interview',
    title: 'Interview',
    icon: InterviewIcon,
  },
  TECHNICAL: {
    id: 'TECHNICAL',
    key: 'technical',
    title: 'Technical',
    icon: TechnicalIcon,
  },
  CULTURAL: {
    id: 'CULTURAL',
    key: 'cultural',
    title: 'Cultural',
    icon: CulturalIcon,
  },
  REFERENCE: {
    id: 'REFERENCE',
    key: 'reference',
    title: 'Reference',
    icon: ReferenceIcon,
  },
  OFFER: {
    id: 'OFFER',
    key: 'offer',
    title: 'Offer',
    icon: OfferIcon,
  },
  HIRED: {
    id: 'HIRED',
    key: 'hired',
    title: 'Hired',
    icon: HiredIcon,
  },
};

export const recruitmentStepsOptions = () => {
  return Object.values(RECRUITMENT_STEPS_MAP).map(value => ({
    id: value.id,
    title: value.title,
  }));
};

export const STEPS = {
  [RECRUITMENT_STEPS_MAP.SOURCED.title]: RECRUITMENT_STEPS_MAP.SOURCED,
  [RECRUITMENT_STEPS_MAP.APPLIED.title]: RECRUITMENT_STEPS_MAP.APPLIED,
  [RECRUITMENT_STEPS_MAP.SCREENING.title]: RECRUITMENT_STEPS_MAP.SCREENING,
  [RECRUITMENT_STEPS_MAP.INTERVIEW.title]: RECRUITMENT_STEPS_MAP.INTERVIEW,
  [RECRUITMENT_STEPS_MAP.TECHNICAL.title]: RECRUITMENT_STEPS_MAP.TECHNICAL,
  [RECRUITMENT_STEPS_MAP.CULTURAL.title]: RECRUITMENT_STEPS_MAP.CULTURAL,
  [RECRUITMENT_STEPS_MAP.REFERENCE.title]: RECRUITMENT_STEPS_MAP.REFERENCE,
  [RECRUITMENT_STEPS_MAP.OFFER.title]: RECRUITMENT_STEPS_MAP.OFFER,
  [RECRUITMENT_STEPS_MAP.HIRED.title]: RECRUITMENT_STEPS_MAP.HIRED,
};
